import { render } from "./TPInquiryModal.vue?vue&type=template&id=035f8c3a&scoped=true&ts=true"
import script from "./TPInquiryModal.vue?vue&type=script&lang=ts"
export * from "./TPInquiryModal.vue?vue&type=script&lang=ts"

import "./TPInquiryModal.vue?vue&type=style&index=0&id=035f8c3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035f8c3a"]])

export default __exports__